import { useEffect, useState } from "react";
import { navLinks } from "@/mocks/guatian";

const colB = [
  { t: "实时追更", href: "#updates", d: "滚动更新的最新动态" },
  { t: "反转档案", href: "#reversal", d: "方向性转向取证记录" },
  { t: "事件时间线", href: "#timeline", d: "热点完整编年脉络" },
];

const colC = [
  { t: "阅读专区", href: "#columns", d: "深读与舆情方法论" },
  { t: "吃瓜指南", href: "#guide", d: "站内信息口径与 FAQ" },
  { t: "关于我们", href: "#about", d: "团队与内容原则" },
];

export default function Footer() {
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 600);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <footer className="bg-background-200">
      <div className="mx-auto max-w-[1280px] px-4 py-12 md:px-6">
        <div className="grid gap-10 lg:grid-cols-[1.4fr_1fr_1fr_1.2fr]">
          <div>
            <a href="#top" className="flex items-center gap-2.5">
              <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-primary-700 text-background-50">
                <i className="ri-thunderstorms-fill text-lg" aria-hidden="true"></i>
              </span>
              <span className="flex flex-col leading-none">
                <span className="text-2xl font-normal text-foreground-950" style={{ fontFamily: "var(--font-label)" }}>
                  大雷<span className="text-accent-600">网站</span>
                </span>
                <span className="mt-1 text-[11px] tracking-[0.18em] text-foreground-500">吃瓜追更 · 反转不止</span>
              </span>
            </a>
            <p className="mt-4 max-w-xs text-sm leading-6 text-foreground-600">
              一个让信息归位的吃瓜平台。我们重建时间线、标注来源、分清已证实与待证实，陪你理性追更每个反转。
            </p>
            <div className="mt-4 flex items-center gap-2 text-sm text-foreground-600">
              <i className="ri-mail-send-line text-primary-600" aria-hidden="true"></i>
              <a href="mailto:hello@dalei-news.example" className="transition hover:text-primary-700">hello@dalei-news.example</a>
            </div>
          </div>

          <nav aria-label="栏目录入">
            <h3 className="text-sm font-bold text-foreground-950">关注栏目</h3>
            <ul className="mt-4 space-y-3">
              {colB.map((c) => (
                <li key={c.t}>
                  <a href={c.href} className="group flex flex-col text-sm">
                    <span className="font-medium text-foreground-800 transition group-hover:text-primary-700">{c.t}</span>
                    <span className="text-xs text-foreground-400">{c.d}</span>
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          <nav aria-label="更多内容">
            <h3 className="text-sm font-bold text-foreground-950">更多内容</h3>
            <ul className="mt-4 space-y-3">
              {colC.map((c) => (
                <li key={c.t}>
                  <a href={c.href} className="group flex flex-col text-sm">
                    <span className="font-medium text-foreground-800 transition group-hover:text-primary-700">{c.t}</span>
                    <span className="text-xs text-foreground-400">{c.d}</span>
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          <div>
            <h3 className="text-sm font-bold text-foreground-950">快速导航</h3>
            <ul className="mt-4 flex flex-wrap gap-2">
              {navLinks.map((l) => (
                <li key={l.id}>
                  <a
                    href={`#${l.id}`}
                    className="inline-flex items-center gap-1 rounded-md border border-background-300 bg-background-50 px-3 py-1.5 text-sm text-foreground-700 transition hover:border-primary-300 hover:text-primary-700"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
            <p className="mt-5 rounded-lg bg-background-50/60 p-3.5 text-xs leading-5 text-foreground-500">
              本站对站内内容坚持来源标注与状态分层，关键信息以官方口径与多方可验证来源为准。若有偏差，欢迎反馈更正。
            </p>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-300 pt-6 sm:flex-row">
          <p className="text-xs text-foreground-500">
            © 2026 大雷网站 · 不做标题党，只做让信息归位的人
          </p>
          <div className="flex items-center gap-2 text-xs text-foreground-400">
            <a href="#top" className="transition hover:text-primary-700">回到顶部</a>
            <span aria-hidden="true">·</span>
            <a href="#guide" className="transition hover:text-primary-700">内容原则</a>
            <span aria-hidden="true">·</span>
            <a href="#subscribe" className="transition hover:text-primary-700">订阅追更</a>
          </div>
        </div>
      </div>

      {showTop && (
        <button
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="fixed bottom-6 right-6 z-40 flex h-11 w-11 items-center justify-center rounded-full bg-primary-600 text-background-50 shadow-[0_10px_24px_-10px_rgba(0,0,0,0.3)] transition hover:bg-primary-700"
          aria-label="回到顶部"
        >
          <i className="ri-arrow-up-line text-lg" aria-hidden="true"></i>
        </button>
      )}
    </footer>
  );
}